import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { AddOrder, AddPlan, Invoice, InvoiceList, Search, Filter, Export, paymentStatus, Import, importFile, PaymentImportTitle } from '../../../Constant';
import { viewInvoiceTable, viewInvoiceTableRole, getCustomers, getCustomersRole, deleteInvoice, deleteInvoiceRole, publicSampleDownloadPayment } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
import moment from 'moment';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import Typeahead from '../../../CommonElements/TypeAhead';
import { invoiceColumns } from '../ColumnHeader/Header';
import PopupImport from '../../Common/Popup/popupImport';
import ImportPaymentPopup from '../../Common/Import/ImportPayment';

const InvoiceContainer = () => {
    const [spinnerTrans, setspinnerTrans] = useState(false);
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' };
    const [invoiceLists, setInvoiceList] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
        start: '',
        end: '',
        customer: '',
        orderStatus: '',
        paymentStatus: ''
    });
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [apiCustomer, setapiCustomer] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const isSearched = useRef(null);
    const isPaymentstatus = useRef(null);
    const [isCustomer, setIsCustomer] = useState(filters.customer);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [importDrpodown, setimportDrpodown] = useState(false);
    const [modalImportDue, setModalImportDue] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });
    const fileImport = <span className='billerqColor bolder '>
        <h3>{importFile}</h3>
    </span>

    const payStatusOptions = [
        { value: "pending", label: "Pending" },
        { value: "partially_paid", label: "Partially Paid" },
        { value: "paid", label: "Paid" }

    ];

    useEffect(() => {
        fetchInvoice(1);
        customerData();
    }, []);

    useEffect(() => {
        const customerOptions = apiCustomer.map((customer) => ({
            value: customer.id,
            label: customer.name,
        }));
        setCustomerOptions(customerOptions);
    }, [apiCustomer]);

    const toggleImport = () => setimportDrpodown(!importDrpodown);

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchInvoice(currentPage, perPage, filters.search, filters.start, filters.end, isCustomer?.value, filters.orderStatus, filters.paymentStatus, column.id, newOrder);
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handleChange = (selectedOption) => {
        setIsCustomer(selectedOption);
    };

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const customerData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomers : getCustomersRole);
        if (data.status === true) {
            setapiCustomer(data.data);
        } else {
            handleApiError(data.status);
        }
    };

    const handlePaymentClick = (id, cust_id) => {
        const payFormURL = `${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${id}&customer_id=${cust_id}`;
        navigate(payFormURL);

    }

    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        const deleteInvoices = () => {
            SweetAlert.fire({
                title: 'Confirm deletion?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'cancel',
                reverseButtons: true
            }).then(async (result) => {
                setLoading(true)
                if (result.value) {
                    const deleteRes = { order_id: row.id }
                    const invoiceDelete = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? deleteInvoice : deleteInvoiceRole, deleteRes);
                    if (invoiceDelete.status == 200) {
                        if (invoiceDelete.data.status == true) {
                            SweetAlert.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            );
                            fetchInvoice(currentPage, perPage, filters.search, filters.start, filters.end, filters.customer, filters.orderStatus, filters.paymentStatus, sortConfig.column, sortConfig.order);
                        } else {
                            toast.error(invoiceDelete.data.message);
                            setLoading(false)
                        }
                    } else {
                        handleApiError(invoiceDelete.status);
                    }
                }
                setLoading(false)
            })
        }

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    <DropdownItem style={toggleStyle} onClick={() => handlePaymentClick(row.id, row.customer_id)}>Invoice</DropdownItem>
                    {row.payment_status === "pending" && (authState.userRole === 1 || authState.permissions.includes('delete-invoice')) &&
                        <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px', margin: '0' }} onClick={() => deleteInvoices()}>Delete</DropdownItem>
                    }
                </DropdownMenu>
            </Dropdown>
        );
    };

    const fetchInvoice = async (page, size = perPage, searchKey = "", start_date = '', end_date = '', customer_id = '', orderStatus = '', payment_status = '', sortBy = '', sortOrder = '') => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewInvoiceTable +
            `?page=${page}&page_length=${size}&search=${searchKey}&customer_id=${customer_id}
            &start_date=${start_date}&end_date=${end_date}&payment_status=${orderStatus}
            &sort_by=${sortBy}&sort_order=${sortOrder}` : viewInvoiceTableRole + `?page=${page}&page_length=${size}
            &search=${searchKey}&customer_id=${customer_id}&start_date=${start_date}&end_date=${end_date}
            &payment_status=${orderStatus}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setInvoiceList(response.data.data.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    Sub: <span>{e.bin_account}</span>,
                    Customer: e.customer_name,
                    Subs: e.subscriber_id,
                    Amount: e.amount,
                    balance: e.balance,
                    InvoiceDate: e.invoice_date,
                    PlanStartDate: e.due_date,
                    PlanDate: e.plan_date,
                    InvoiceNo: e.invoice_number,
                    Status: e.status,
                    order_status: e.order_status,
                    id: e.id,
                    customer_id: e.customer_id,
                    con_type: e.invoice_type,
                    payment_status: e.payment_status,
                    dueDate: e.due_date,
                    CreatedBy: e.created_by,
                    Comments: e.comments
                }
            }))
            setTotalRows(response.data.total);
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };
    const exportInvoiceExcel = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewInvoiceTable + `?export=wallet_data&search=${filters?.search ? filters.search : ''}
            &start_date=${filters?.start ? filters.start : ''}&end_date=${filters?.end ? filters.end : ''}
            &customer_id=${filters?.customer ? filters.customer : ''}&paymentStatus=${filters?.orderStatus ? filters.orderStatus : ''}
            &sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`
            : viewInvoiceTableRole + `?export=wallet_data&search=${filters?.search ? filters.search : ''}
            &start_date=${filters?.start ? filters.start : ''}&end_date=${filters?.end ? filters.end : ''}
            &customer_id=${filters?.customer ? filters.customer : ''}&paymentStatus=${filters?.orderStatus ? filters.orderStatus : ''}
            &sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ invoice_number, subscriber_id, customer_name, amount, invoice_date, created_date, payment_status, }) => ({ Invoice_No: invoice_number, Bin_Id: subscriber_id, Customer: customer_name, Amount: amount, Invoice_Date: invoice_date, Plan_Start_Date: created_date, Payment_Status: payment_status, Recuring: invoice_date }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
            XLSX.writeFile(wb, 'Invoice_data.xlsx');
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };

    const exportInvoicePdf = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewInvoiceTable + `?export=wallet_data&search=${filters?.search ? filters.search : ''}
            &start_date=${filters?.start ? filters.start : ''}&end_date=${filters?.end ? filters.end : ''}
            &customer_id=${filters?.customer ? filters.customer : ''}&paymentStatus=${filters?.orderStatus ? filters.orderStatus : ''}
            &sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`
            : viewInvoiceTableRole + `?export=wallet_data&search=${filters?.search ? filters.search : ''}
            &start_date=${filters?.start ? filters.start : ''}&end_date=${filters?.end ? filters.end : ''}
            &customer_id=${filters?.customer ? filters.customer : ''}&paymentStatus=${filters?.orderStatus ? filters.orderStatus : ''}
            &sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.map(({ invoice_number, subscriber_id, customer_name, amount, invoice_date, created_date, payment_status, }) => ({ invoice_number, subscriber_id, customer_name, amount, invoice_date, created_date, payment_status, }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["Invoice No", "Bin Id", "Customer", "Amount", "Invoice Date", "Plan Start Date", "Payment Status",];
            const rows = dataToExport.map(({ invoice_number, subscriber_id, customer_name, amount, invoice_date, created_date, payment_status, }) => [invoice_number, subscriber_id, customer_name, amount, invoice_date, created_date, payment_status,]);
            doc.autoTable({
                head: [columns],
                body: rows
            });
            doc.save("invoice_data.pdf");
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };

    const handlePageChange = page => {
        fetchInvoice(page, perPage, filters.search, filters.start, filters.end, filters.customer, filters.orderStatus, filters.paymentStatus, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchInvoice(page, newPerPage, filters.search, filters.start, filters.end, filters.customer, filters.orderStatus, filters.paymentStatus, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const handleModalImport = () => {
        setModalImportDue(!modalImportDue);
    }

    const handleImportpaymentLog = () => {
        const navigatetoLog = `${process.env.PUBLIC_URL}/billing/invoice/payment-log`;
        navigate(navigatetoLog);
    }

    const handleFilter = async (e) => {
        e.preventDefault();
        const search = isSearched.current.value;
        const customerId = isCustomer?.value;
        const paymentStatus = isPaymentstatus.current.value;
        const start = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        setFilters({
            search,
            start,
            end,
            customerId,
            paymentStatus
        });
        fetchInvoice(1, perPage, search, start, end, customerId, paymentStatus);
    };


    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            <Breadcrumbs mainTitle={Invoice} parent="Billing" title={Invoice} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -35px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{InvoiceList}</H3>
                    <div>
                        <CardBody className="dropdown-basic" style={{ borderRadius: '5px' }}>
                            <Link to={`${process.env.PUBLIC_URL}/billing/subscription-add`} className="btn btn-primary me-md-2 button-addsale">
                                {AddPlan}
                            </Link>
                            <Link to={`${process.env.PUBLIC_URL}/billing/order-add`} className="btn btn-primary button-addsale">
                                {AddOrder}
                            </Link>
                            <Dropdown className='ms-2' isOpen={importDrpodown} toggle={toggleImport}>
                                <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary me-md-2">
                                    {Import} <i className="icofont icofont-arrow-down"></i>
                                </DropdownToggle>
                                <DropdownMenu container="body">
                                    <DropdownItem style={toggleStyle} onClick={() => handleModalImport()}><i className="fa fa-file-text-o me-2"></i> Import Payment</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => handleImportpaymentLog()}><i className="fa fa-list-alt me-2"></i> Imported Payment Logs</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }}
                                    className="btn btn-primary button-addsale">
                                    {Export} <i className="icofont icofont-arrow-up"></i>
                                </DropdownToggle>
                                <DropdownMenu container="body">
                                    <DropdownItem style={toggleStyle} onClick={() => exportInvoiceExcel()}>
                                        <i className="fa fa-file-excel-o me-2"></i> Excel
                                    </DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => exportInvoicePdf()}>
                                        <i className="fa fa-file-pdf-o me-2"></i> Pdf
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </CardBody>
                    </div>
                </CardHeader>
                <CardBody>
                    <span className=''>
                        <Form className="needs-validation" noValidate onSubmit={handleFilter}>
                            <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
                                <Col sm="12" md='5' lg='2'>
                                    <input name='search' className="form-control" placeholder={Search} id="validationCustom01" type="text" ref={isSearched}
                                    />
                                </Col>
                                <Col sm="12" md="5" lg='2' className="form-element">
                                    <div style={{ position: 'relative', zIndex: 2 }}>
                                        <DatePicker
                                            className="form-control digits w-100"
                                            selectsRange={true}
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={(update) => {
                                                setDateRange(update);
                                            }}
                                            isClearable={true}
                                            monthsShown={2}
                                            popperPlacement="bottom"
                                            calendarClassName='parallel-calendar'
                                            placeholderText='Select Date Range'
                                            dateFormat="dd/MM/yyyy"
                                        />
                                    </div>
                                </Col>
                                <Col sm="12" md="5" lg="2" className="form-element">
                                    <Typeahead
                                        options={customerOptions}
                                        onChange={handleChange}
                                        placeholder="Customer..."
                                    />
                                </Col>
                                <Col sm="12" md="5" lg='2' className="form-element">
                                    <select className="form-select" ref={isPaymentstatus}>
                                        <option value="">{paymentStatus}</option>
                                        {payStatusOptions.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </Col>
                                <Col sm="12" md="5" lg='1' className="custom-filtrs">
                                    <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={invoiceColumns(authState, ActionCell)}
                            data={invoiceLists}
                            progressPending={loading}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRow}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
            <PopupImport isOpen={modalImportDue} title={fileImport} toggler={handleModalImport} >
                <ImportPaymentPopup
                    setModalImport={setModalImportDue}
                    sampleImportApi={publicSampleDownloadPayment}
                    imporTitle={PaymentImportTitle}
                    tablerenderFunc={fetchInvoice}
                    currentPage={currentPage}
                    perPage={perPage}
                />
            </PopupImport>
        </Fragment >
    );
};

export default InvoiceContainer;